<template>
  <div>
    <section class="login">
      <div
        class="picture"
        :style="
          `background: url(${selectedBanner}); background-size: cover; background-position: top center;`
        "
      ></div>

      <div class="content-form">
        <form v-if="!resetPassword" @submit.prevent="getCaptcha" class="form">
          <div class="title">
            <svgHelper name="logoGray"></svgHelper>
            <h1>Welcome back!</h1>
            <span>Log in with email</span>
          </div>

          <div class="form-floating">
            <input
              v-model="email"
              type="email"
              class="form-control"
              :class="invalid ? 'is-invalid' : ''"
              id="email"
              placeholder="name@example.com"
            />
            <label for="email">Email</label>
          </div>
          <div class="form-floating">
            <input
              :class="invalid ? 'is-invalid' : ''"
              v-model="password"
              :type="passwordType"
              class="form-control"
              id="password"
              placeholder="Password"
            />
            <label for="password">Password</label>
            <div
              class="toggle"
              v-html="passwordType === 'password' ? eyeOff : eyeOn"
              @click="togglePassword"
            ></div>
          </div>
          <div class="text-center">
            <span @click="resetPassword = true">Forgot your password?</span>
          </div>
          <div class="form-footer">
            <div class="d-grid">
              <button :disabled="isLoading" class="btn btn-primary" type="submit">
                <div>
                  <div v-if="isLoading" class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  Log In
                </div>
              </button>
            </div>
            <div class="contact">
              <div class="account">
                Don't have an account?
                <div>
                  <router-link :to="{ name: 'register-candidate' }"
                    >Sign up as candidate</router-link
                  >
                </div>
                <div>
                  <router-link :to="{ name: 'register-employers' }"
                    >Sign up as employer
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </form>

        <form v-else @submit.prevent="sendNewPassword" class="form">
          <div class="title">
            <svgHelper name="logoGray"></svgHelper>
            <h1>Reset password</h1>
            <span>Enter your email</span>
          </div>

          <div class="form-floating">
            <input
              v-model="email"
              type="email"
              class="form-control"
              :class="invalid ? 'is-invalid' : ''"
              id="email"
              placeholder="name@example.com"
            />
            <label for="email">Email</label>
          </div>
          <div class="text-center">
            <span @click="resetPassword = false"><span>Go back to</span> Log In</span>
          </div>
          <div class="form-footer">
            <div class="d-grid">
              <button
                :disabled="isLoading"
                @click="sendNewPassword"
                class="btn btn-primary"
                type="button"
              >
                <div>
                  <div v-if="isLoading" class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>

                  Reset password
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
    <FooterNew />
    <div v-if="isPageLoading" class="page-loader">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { userRoleMixin } from '../../mixins/userRoleMixin';
import axios from 'axios';
import FooterNew from './FooterNew.vue';
import titleMixin from '../../mixins/titleMixin';
export default {
  mixins: [userRoleMixin, titleMixin],
  title() {
    return 'Log In | Jobshark';
  },
  components: {
    FooterNew,
  },
  data: () => ({
    currentYear: new Date().getFullYear(),
    isLoading: false,
    isPageLoading: false,
    passwordType: 'password',
    banners: [
      '/img/banners/Picture1.jpg',
      '/img/banners/Picture2.jpg',
      '/img/banners/Picture3.jpg',
      '/img/banners/Picture4.jpg',
      '/img/banners/Picture5.jpg',
    ],
    email: '',
    password: '',
    invalid: false,
    reToken: '',
    resetPassword: false,
    selectedBanner: '',
    eyeOff: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 24" fill="none">
  <g clip-path="url(#clip0_2763_7769)">
    <path d="M18.44 17.9337C16.7306 19.2367 14.6491 19.9585 12.5 19.9937C5.5 19.9937 1.5 11.9937 1.5 11.9937C2.74389 9.67557 4.46914 7.65029 6.56 6.05368M10.4 4.23368C11.0883 4.07256 11.7931 3.99202 12.5 3.99368C19.5 3.99368 23.5 11.9937 23.5 11.9937C22.893 13.1293 22.1691 14.1984 21.34 15.1837M14.62 14.1137C14.3454 14.4084 14.0141 14.6448 13.6462 14.8088C13.2782 14.9728 12.8809 15.0609 12.4781 15.068C12.0753 15.0752 11.6752 15.0011 11.3016 14.8502C10.9281 14.6993 10.5887 14.4747 10.3038 14.1898C10.019 13.905 9.79439 13.5656 9.64351 13.1921C9.49262 12.8185 9.41853 12.4184 9.42563 12.0156C9.43274 11.6128 9.52091 11.2155 9.68488 10.8475C9.84884 10.4795 10.0853 10.1483 10.38 9.87368" stroke="#8A7C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.5 0.993652L23.5 22.9937" stroke="#8A7C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_2763_7769">
      <rect width="24" height="24" fill="white" transform="translate(0.5 -0.00634766)"/>
    </clipPath>
  </defs>
</svg>`,
    eyeOn: `<svg width="25" height="25" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.44 14.9322C16.7306 16.2352 14.6491 16.9571 12.5 16.9922C5.5 16.9922 1.5 8.99221 1.5 8.99221C2.74389 6.67411 4.46914 4.64882 6.56 3.05221M10.4 1.23221C11.0883 1.07109 11.7931 0.990551 12.5 0.992213C19.5 0.992213 23.5 8.99221 23.5 8.99221C22.893 10.1278 22.1691 11.1969 21.34 12.1822M14.62 11.1122C14.3454 11.407 14.0141 11.6434 13.6462 11.8073C13.2782 11.9713 12.8809 12.0595 12.4781 12.0666C12.0753 12.0737 11.6752 11.9996 11.3016 11.8487C10.9281 11.6978 10.5887 11.4732 10.3038 11.1884C10.019 10.9035 9.79439 10.5642 9.64351 10.1906C9.49262 9.81705 9.41853 9.41693 9.42563 9.01412C9.43274 8.61131 9.52091 8.21406 9.68488 7.84606C9.84884 7.47806 10.0853 7.14686 10.38 6.87221" stroke="#8A7C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  }),

  methods: {
    ...mapActions(['retrieveUserProfile', 'retrieveUserProfileMarketing']),
    randomBanner() {
      const randomIndex = Math.floor(Math.random() * this.banners.length);
      this.selectedBanner = this.banners[randomIndex];
    },
    getCaptcha() {
      if (!this.validateEmail(this.email)) {
        this.$toasted.error('Please enter valid email address.', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }
      let vm = this;
      const SIGNIN = () => this.signin();
      grecaptcha
        .execute('6LdTF5MqAAAAACaGiGhB9RJdrmDU9mcatUuj1vom', { action: 'login' })
        .then(function(token) {
          vm.reToken = token;
          SIGNIN();
        });
    },
    signin() {
      const email = this.email;
      const password = this.password;
      this.isLoading = true;
      this.$store
        .dispatch('retrieveToken', {
          email,
          password,
          'g-recaptcha-response': this.reToken,
        })
        .then(response => {
          const { user_type } = response.data;

          if (user_type == this.userType('admin')) {
            this.retrieveUserProfile().then(() => {
              this.$router.push({ name: 'admin-jobs' });
              /*    this.$toasted.success('You are successfully logged in as Admin.', {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 3000,
              }); */
            });
          } else if (user_type == this.userType('recruiter')) {
            this.$router.push({ name: 'recruiter-jobs' });

            /*   this.$toasted.success('You are successfully logged in as Recruiter.', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            }); */
          } else if (user_type == this.userType('user')) {
            this.$router.push({ name: 'manager-user-jobs' });

            /*  this.$toasted.success('You are successfully logged in as User.', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            }); */
          } else if (user_type == this.userType('manager')) {
            this.$store
              .dispatch('managerStoreModule/retrieveManagerProfile')
              .then(() => {
                this.$router.push({ name: 'manager-jobs' });

                /*    this.$toasted.success('You are successfully logged in as Manager.', {
                  theme: 'bubble',
                  icon: 'fa-check-circle',
                  position: 'bottom-right',
                  duration: 5000,
                }); */
              })
              .catch(err => {
                this.$toasted.error(errorService(err), {
                  theme: 'bubble',
                  icon: 'fa-check-circle',
                  position: 'bottom-right',
                  duration: 5000,
                });
              });
          } else if (user_type == this.userType('user')) {
            /*   this.$toasted.success('You are successfully logged in as User.', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            }); */
          } else if (user_type == this.userType('candidate')) {
            if (this.$route.params.jobad_id) {
              localStorage.setItem('applyId', this.$route.params.jobad_id);
            }
            this.$router.push({ name: 'user-profile' });

            /*      this.$toasted.success('You are successfully logged in as Candidate.', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            }); */
          } else if (user_type == this.userType('marketing')) {
            this.retrieveUserProfileMarketing().then(() => {
              this.$router.push({ name: 'admin-marketing-jobs' });
            });
          }
        })
        .catch(err => {
          this.isLoading = false;
          if (err.response) {
            if (err.response.status === 429) {
              this.$toasted.error(
                'Too many attempts. This operation is temporarily blocked for 10 minutes.',
                {
                  theme: 'bubble',
                  position: 'bottom-right',
                  duration: 5000,
                },
              );
              return;
            }
          }
          this.$toasted.error('Check your email address and password and try again.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    sendNewPassword() {
      if (!this.validateEmail(this.email)) {
        this.$toasted.error('Please enter valid email address.', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }
      axios(`${process.env.VUE_APP_API_URL}/auth/forgotpassword`, {
        method: 'post',
        data: {
          email: this.email,
        },
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$toasted.success(
            'If an account exists with that email, we’ll send you a reset link',
            {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            },
          );
          this.email = '';
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 429) {
              this.$toasted.error(
                'Too many attempts. This operation is temporarily blocked for 10 minutes.',
                {
                  theme: 'bubble',
                  position: 'bottom-right',
                  duration: 5000,
                },
              );
              return;
            }
          }
        });
    },
    togglePassword() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    checkForLogin() {
      if (localStorage.getItem('app_token') && localStorage.getItem('acc')) {
        this.isPageLoading = true;
        const user_type = localStorage.getItem('acc');

        if (user_type == this.userType('admin')) {
          this.retrieveUserProfile().then(() => {
            this.$router.push({ name: 'admin-jobs' });
            /*    this.$toasted.success('You are successfully logged in as Admin.', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 3000,
            }); */
          });
        } else if (user_type == this.userType('recruiter')) {
          this.$router.push({ name: 'recruiter-jobs' });

          /*    this.$toasted.success('You are successfully logged in as Recruiter.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          }); */
        } else if (user_type == this.userType('user')) {
          this.$router.push({ name: 'manager-user-jobs' });

          /*   this.$toasted.success('You are successfully logged in as User.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          }); */
        } else if (user_type == this.userType('manager')) {
          this.$store
            .dispatch('managerStoreModule/retrieveManagerProfile')
            .then(() => {
              this.$router.push({ name: 'manager-jobs' });

              /*  this.$toasted.success('You are successfully logged in as Manager.', {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              }); */
            })
            .catch(err => {
              this.$toasted.error(errorService(err), {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            });
        } else if (user_type == this.userType('user')) {
          /* this.$toasted.success('You are successfully logged in as User.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          }); */
        } else if (user_type == this.userType('candidate')) {
          if (this.$route.params.jobad_id) {
            localStorage.setItem('applyId', this.$route.params.jobad_id);
          }
          this.$router.push({ name: 'user-profile' });
        } else if (user_type == this.userType('marketing')) {
          this.retrieveUserProfileMarketing().then(() => {
            this.$router.push({ name: 'admin-marketing-jobs' });
          });
        }
      }
    },
  },
  mounted() {
    this.randomBanner();
    this.checkForLogin();
  },
};
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
.login {
  display: flex;
  min-height: calc(100vh - 66px);
  font-family: 'Lato', serif !important;
  position: relative;
  .picture {
    flex: 1;
    background-size: cover !important;
    background-position: top center !important;
  }

  .form-floating {
    label {
      left: 0px;
    }
  }

  .content-form {
    display: flex;
    justify-content: center;
    flex: 1;
    background: #f5f5f5;
    padding-top: 80px;
    .form {
      width: 45%;
      padding-bottom: 30px;
      .title {
        text-align: center;
        .svg-icon {
          width: 96px;
          height: auto;
          display: block;
          margin: 0 auto 30px auto;
        }
        h1 {
          color: #f05c00 !important;
          margin-bottom: 25px;
          font-size: 46px !important;
        }
        h3 {
          letter-spacing: 2px;
          margin-bottom: 25px;
          font-size: 21px !important;
        }
        span {
          font-size: 14px;
          color: #82746c;
          position: relative;
          display: inline-block;
          margin-bottom: 48px;
          &::before {
            content: '';
            position: absolute;
            top: 12px;
            left: -104px;
            width: 80px;
            height: 1px;
            background-color: #82746c;
            opacity: 0.4;
          }
          &::after {
            content: '';
            position: absolute;
            top: 12px;
            right: -104px;
            width: 80px;
            height: 1px;
            background-color: #82746c;
            opacity: 0.4;
          }
        }
      }
      .form-floating {
        position: relative;
        margin-bottom: 21px;
        label {
          font-size: 16px;
          color: #685d56;
        }
        .form-control {
          border-radius: 0;
          height: 48px;
        }
        .toggle {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 15px;
          cursor: pointer;
        }
        &.required {
          &::after {
            content: '*';
            position: absolute;
            color: red;
            top: 0;
            right: 8px;
            height: 100%;
            padding-top: 8px;
            display: flex;
            align-items: center;
            font-size: 24px;
            line-height: 0;
          }
        }
      }
      .text-center {
        margin-top: 16px;
        text-align: right;
        user-select: none;
        span {
          color: #0088cc;
          cursor: pointer;
          font-size: 18px;
          span {
            color: #000;
            text-decoration: none;
          }
        }
      }
      .form-check {
        font-size: 14px;
      }
      .form-footer {
        margin-top: 48px;
        .btn {
          background: #000 !important;
          border-color: #000 !important;
          height: 50px;
          text-transform: uppercase;
          div {
            position: relative;
            display: inline-block;
            .spinner-border {
              position: absolute;
              width: 1.4rem;
              height: 1.4rem;
              left: -30px;
              color: #f05c00;
            }
          }
        }
        .contact {
          text-align: center;
          margin-top: 48px;
          a {
            color: #08c;
            font-size: 18px;
            text-decoration: underline;
          }
          span {
            display: inline-block;
            margin-bottom: 8px;
            font-weight: 400;
            font-size: 18px;
            &:first-of-type {
              margin-right: 23px;
            }
            &:nth-of-type(2) {
              text-decoration: underline;
              cursor: pointer;
              font-weight: 600;
            }
          }
          .account {
            font-size: 18px;
            span {
              color: #08c;
              font-size: 18px;
              margin-left: 23px;
              font-weight: 600;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
        .new-code {
          text-align: center;
          margin-top: 18px;
          font-size: 18px;
          span {
            color: #08c;
            font-size: 15px;
            font-weight: 500;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
            &:nth-of-type(2) {
              margin-left: 12px;
            }
          }
        }
      }
    }
  }
}

.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  .spinner-border {
    width: 2.6rem;
    height: 2.6rem;
    color: #f05c00;
  }
}

@media (max-width: 1024px) {
  .login {
    display: block;
    min-height: auto;
    .content-form {
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 60px;
      .form {
        width: 65%;
      }
    }
    .picture {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .login {
    display: block;
    min-height: auto;
    .content-form {
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 60px;
      .form {
        width: 100%;
      }
    }
    .picture {
      display: none;
    }
  }
}
</style>
